import React from 'react';

import { useLoadingState } from '../../../store/hooks';
import { LoaderPropsType } from './types';

/*
 * Display a loader if forceLoader is true or count of loading scope is greater than 0
 * */
const Loader = ({ forceScope, forceLoader, forceMessage, children, style, isMobile }: LoaderPropsType) => {
  const current = useLoadingState(forceScope);
  const message = forceLoader ? null : (forceMessage ? forceMessage : current.message);
  const display = current.count > 0 || forceLoader || message;
  return (
    <>
      {display ?
      <div
        className={isMobile? 'loader-mobile': ''}
        style={{
          backgroundImage: !message ? 'url(\'/assets/images/loading.gif\')' : '',
          width: '100%',
          height: 'inherit',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundColor: 'white',
          backgroundSize: '270px',
          opacity: message ? '1' : '0.9',
          position: 'absolute',
          zIndex: 900,
          left: '0px',
          textAlign: 'center',
          border: 'inherit',
          ...style
        }}
      >
        <label
          className="webkit"
          style={{
            color: '#333D47',
            fontFamily: 'Roboto Condensed',
            fontSize: '20px',
            fontWeight: 'bold',
            letterSpacing: '-0.33px',
            lineHeight: '24px',
            //centered text
            position: 'relative',
            // float: 'left',
            top: '50%',
            // left: '50%'
          }}
        >
          {message}
        </label>
      </div> :
        (children ? children : <></>)
      }
    </>
  );
};

export default Loader;
export * from './types';
